import CONFIG from '../../../config'

import CoreRAF from '../core-raf'

export default
{
    name: 'app-component',

    mixins: [
        CoreRAF
    ],

    data() {
        return {
            CONFIG
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/app-component/index.js